import React from 'react';

import { PlaceholderSize } from 'modules/shared/types';
import { TitleBlocLoader } from 'modules/shared-cms-advanced/components';

export const CarrouselLoader: React.FC<{
    placeholderSize?: PlaceholderSize;
    compactResponsive?: boolean;
    largeLegend?: boolean;
}> = React.memo(({ placeholderSize, compactResponsive, largeLegend }) => {
    return <TitleBlocLoader size={placeholderSize} compactResponsive={compactResponsive} largeLegend={largeLegend} />;
});

export const CarrouseLoaderBuilder = (props: {
    placeholderSize?: PlaceholderSize;
    compactResponsive?: boolean;
    largeLegend?: boolean;
}): React.ReactNode => {
    const { placeholderSize, compactResponsive, largeLegend } = props;
    return (
        <CarrouselLoader
            placeholderSize={placeholderSize}
            compactResponsive={compactResponsive}
            largeLegend={largeLegend}
        />
    );
};
